import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import ProductCard from "@/components/ProductCard";
import { Product } from "@/types/product";

interface SimilarProductsProps {
  currentProductId: string;
  brand: string;
}

const SimilarProducts = ({ currentProductId, brand }: SimilarProductsProps) => {
  const { t } = useTranslation();

  const { data: similarProducts } = useQuery({
    queryKey: ['similar-products', brand],
    enabled: !!brand,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('products')
        .select('*')
        .eq('brand', brand)
        .neq('id', currentProductId)
        .limit(3);

      if (error) throw error;
      return data as Product[];
    }
  });

  if (!similarProducts?.length) return null;

  return (
    <div className="mt-12">
      <h2 className="text-2xl font-bold mb-6">{t('products.similarProducts')}</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {similarProducts.map((product) => (
          <ProductCard 
            key={product.id} 
            product={product}
          />
        ))}
      </div>
    </div>
  );
};

export default SimilarProducts;